import { Ajax } from '@shared/Ajax';

function fetchStationCoords(
    lat: number,
    lon: number,
    alignmentId: number,
    alignmentIndex: number = 0
): JQueryPromise<{
    status: boolean;
    station: StationCoords;
}> {
    return Ajax({
        url: 'api/1/coords/station.json',
        data: {
            lat: lat.toFixed(12),
            lon: lon.toFixed(12),
            alignmentId,
            alignmentIndex,
        },
    });
}

export const MapCoordsService = {
    fetchStationCoords,
};
